module.exports = __webpack_public_path__ + "img/loto_plus_color.87274491.png";